import { useEffect } from "react";
import { ThreePlanogram } from "../store/types";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { Products } from "./Products";
import { Color } from "src/elements";
import { createThreeMesh } from "../store/utils/three";
import { getNonMerchandisableArea } from "@CommonUtils/pog/shelfMerchandising";

interface Props {
  shelf: PlanogramShelf;
  three: ThreePlanogram;
}

export const Shelf = ({ shelf, three }: Props) => {
  useEffect(() => {
    const { mesh, cleanUp } = createThreeMesh({
      scene: three.scene,
      width: shelf.width,
      height: shelf.thickness,
      depth: shelf.depth,
      x: shelf.getXLeft(),
      y: shelf.getYBottom(),
      z: 0,
      color: Color.forest950,
      renderOrder: 2,
    });

    mesh.userData = {
      type: "shelf",
      shelf,
    };

    return cleanUp;
  }, [shelf, three]);

  useEffect(() => {
    const area = getNonMerchandisableArea(shelf);
    if (area.width === 0) return;

    const { cleanUp } = createThreeMesh({
      scene: three.scene,
      width: area.width,
      height: shelf.thickness + 2,
      depth: shelf.depth + 2,
      x: shelf.getXLeft() + area.xOffset,
      y: shelf.getYBottom() - 1,
      z: -1,
      color: Color.alertMediumIcon,
      opacity: 0.7,
      renderOrder: 3,
    });

    return cleanUp;
  }, [shelf, three]);

  return <Products products={shelf.items} three={three} />;
};
